import React from 'react';
import { ScrollView, View } from 'react-native';
import Column, { ColumnType } from './components/Column';
import { twMerge } from 'tailwind-merge';

export type ColumnProps = {
  id: number;
  texts: string[];
  variant?: 'primary' | 'secondary';
};

interface TableProps {
  columns: ColumnProps[];
  className?: string;
}

const bgColorByIndex = (
  variant: ColumnProps['variant'],
  index: number
): string => {
  if (variant === 'secondary') {
    if (index % 2 === 0) {
      return 'bg-error-400';
    }
    return 'bg-error-100';
  }

  if (index % 2 === 0) {
    return 'bg-light-100';
  }
  return 'bg-gray-100';
};

const Table: React.FC<TableProps> = ({ columns, className }) => {
  return (
    <ScrollView
      className={twMerge('flex-row md:justify-center py-2', className)}
      horizontal
      showsHorizontalScrollIndicator={false}
    >
      {columns.map((column) => {
        return (
          <View className="mr-[1px]" key={column.id}>
            {column.texts.map((text, index) => {
              const columnTypeA = (): ColumnType => {
                if (index === 0) {
                  return ColumnType.header;
                } else if (index === column.texts.length - 1) {
                  return ColumnType.total;
                } else {
                  return ColumnType.default;
                }
              };

              const columnType = columnTypeA();

              const bgColor =
                columnType === ColumnType.default
                  ? bgColorByIndex(column.variant, index)
                  : '';

              return (
                <Column
                  key={index}
                  backgoundColor={bgColor}
                  type={columnType}
                  text={text}
                  variant={column.variant}
                />
              );
            })}
          </View>
        );
      })}
    </ScrollView>
  );
};

export default Table;
